module.exports = __webpack_public_path__ + "static/media/logo.886ba58a.png";